import { createSlice } from "@reduxjs/toolkit";

export const leadstatusUpdateSlice = createSlice({
  name: "leadInfo",
  initialState: {
    leadStatusValue: {},
    leadStatusArray: [],
  },
  reducers: {
    updateLeadStatusInfo(state, action) {
      const { leadId, data } = action.payload;

      const existingIndex = state.leadStatusArray.findIndex(
        (item) => item.leadId === leadId
      );

      if (existingIndex !== -1) {
        // If leadId exists, update its data
        state.leadStatusArray[existingIndex].data = data;
      } else {
        // If leadId is new, add it to the array
        state.leadStatusArray.push({ leadId, data });
      }
    },
  },
});
export const { updateLeadStatusInfo } = leadstatusUpdateSlice.actions;

export default leadstatusUpdateSlice.reducer;
